<template>
  <div class="app">
    <!-- 头部区域 -->
    <header class="header">
      <div class="container">
        <h1 class="title">省级非遗代表性传承人</h1>
        <p class="subtitle">北张正骨术第七代嫡系传承人 - 张进</p>
      </div>
    </header>

    <!-- 主体内容 -->
    <main class="main container">
      <!-- 传承人卡片 -->
      <section class="section intro">
        <div class="intro-card">
          <div class="intro-image">
            <img src="../../../assets/yyimages/yyindex-8.png" alt="张进照片" class="rounded">
          </div>
          <div class="intro-info">
            <h2 class="name">张进</h2>
            <div class="basic-info">
              <p><span>出生年月：</span>1976年4月19日</p>
              <p><span>政治面貌：</span>中共党员</p>
              <p><span>学历：</span>本科</p>
              <p><span>职位：</span>芦淞区中医骨伤专科医院院长、主治医师</p>
              <p><span>非遗传承：</span>省级非遗北张正骨术第七代嫡系传承人</p>
            </div>
            <div class="honor">
              <p>2024年2月入选传统医药类湖南省第五批省级非物质文化遗产项目代表性传承人</p>
            </div>
          </div>
        </div>
      </section>

      <!-- 传承背景 -->
      <section class="section heritage">
        <h2 class="section-title">传承背景</h2>
        <div class="heritage-content">
          <p>张进是北张正骨术创始人张光靖的第七代嫡系子孙，从小耳濡目染学习中医正骨。1996年，大学毕业后跟随北张正骨第六代核心传承人伯父张健民、姑妈张正平学习了3年的家传正骨术，并师从北张正骨第六代传人“全国十大骨伤名老中医”、“全国名老中医"孙达武教授学习北张正骨一年。</p>
          <p>后又分别在株洲市中医伤科医院、湖南省中医大学附属第一医院进修学习现代骨科创伤科学。通过几年的勤学苦练，张进将祖传之术与现代医学融会贯通，正骨技术炉火纯青。</p>
        </div>
      </section>

      <!-- 工作经历 -->
      <section class="section experience">
        <h2 class="section-title">工作经历与贡献</h2>
        <div class="experience-timeline">
          <div class="timeline-item">
            <div class="timeline-year">2001年</div>
            <div class="timeline-content">
              <p>放弃留在省城医院工作的机会，回到偏僻、交通闭塞的芦淞区姚家坝卫生院当起了骨科医生</p>
            </div>
          </div>
          <div class="timeline-item">
            <div class="timeline-year">至今</div>
            <div class="timeline-content">
              <p>20多年来，始终扎根农村基层医院，传教带徒，精研技术，娴熟运用“北张正骨”手法及祖传的外敷、内服药治疗各类骨折，对各种创伤骨折、陈旧性骨折骨不连、老年骨质疏松、退行性骨病等均有独特疗效</p>
            </div>
          </div>
          <div class="timeline-item">
            <div class="timeline-year">2016年</div>
            <div class="timeline-content">
              <p>带领团队申请的"一种用于勃朗式牵引架包扎的包扎带机包扎方法"获得国家发明专利</p>
            </div>
          </div>
        </div>
      </section>

      <!-- 荣誉成就 -->
      <section class="section honors">
        <h2 class="section-title">荣誉与成就</h2>
        <div class="honors-grid">
          <div class="honor-card" v-for="honor in honorsList" :key="honor">
            <div class="honor-icon">
              <i class="fas fa-trophy"></i>
            </div>
            <p>{{ honor }}</p>
          </div>
        </div>
      </section>

      <!-- 传承意义 -->
      <section class="section significance">
        <h2 class="section-title">传承意义</h2>
        <div class="significance-content">
          <p>张进作为省级非遗北张正骨术的代表性传承人，不仅继承了祖辈的正骨技艺，更将传统中医与现代医学相结合，推动了北张正骨术的发展与创新。他扎根基层、服务百姓的精神，体现了非遗传承人的社会责任感和使命担当。</p>
          <p>在他的带领下，北张正骨术得到了更广泛的传播和应用，为更多骨伤患者带来了福音，也为中医正骨文化的传承与发展做出了重要贡献。</p>
        </div>
      </section>
    </main>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <p>芦淞区中医骨伤专科医院 &copy; {{ currentYear }} 版权所有</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "HeritageInheritorIntroduction",
  data() {
    return {
      honorsList: [
        "全国卫生先进工作者",
        "全国基层名老中医药专家",
        "湖南省劳动模范",
        "株洲市最美乡村医生",
        "株洲市优秀共产党员",
        "株洲市知识型优秀人才",
        "新时代最美芦淞人",
        "张进劳模创新工作室被评为湖南省示范性劳模和工匠人才创新工作室"
      ]
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped>
/* 基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

body {
  background-color: #f9f9f9;
  color: #333;
  line-height: 1.6;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 头部样式 */
.header {
  background: linear-gradient(135deg, #4CAF50, #388E3C);
  color: white;
  padding: 100px 0 70px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.header::after {
  content: "";
  position: absolute;
  bottom: -50px;
  left: 0;
  width: 100%;
  height: 100px;
  background: white;
  border-radius: 50% 50% 0 0;
}

.title {
  font-size: 3rem;
  margin-bottom: 20px;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.subtitle {
  font-size: 1.3rem;
  opacity: 0.9;
  max-width: 800px;
  margin: 0 auto;
}

/* 主体内容样式 */
.main {
  padding: 60px 0;
}

.section {
  margin-bottom: 80px;
  position: relative;
}

.section-title {
  font-size: 2.2rem;
  text-align: center;
  margin-bottom: 40px;
  color: #333;
  position: relative;
}

.section-title::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 3px;
  background-color: #4CAF50;
  border-radius: 3px;
}

/* 传承人卡片样式 */
.intro-card {
  background-color: white;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 60px;
  transition: transform 0.3s ease;
}

.intro-card:hover {
  transform: translateY(-5px);
}

.intro-image {
  flex: 1;
  min-width: 400px;
  height: 350px;
  overflow: hidden;
}

.intro-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.intro-card:hover .intro-image img {
  transform: scale(1.03);
}

.intro-info {
  flex: 1;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.name {
  font-size: 2.2rem;
  color: #333;
  margin-bottom: 20px;
  position: relative;
  display: inline-block;
}

.name::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 80px;
  height: 3px;
  background-color: #4CAF50;
  border-radius: 3px;
}

.basic-info {
  margin-bottom: 20px;
}

.basic-info p {
  margin-bottom: 12px;
  font-size: 1.1rem;
  color: #555;
}

.basic-info span {
  font-weight: bold;
  color: #4CAF50;
  width: 120px;
  display: inline-block;
}

.honor {
  font-size: 1.1rem;
  color: #4CAF50;
  font-weight: bold;
}

/* 传承背景样式 */
.heritage-content {
  background-color: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
}

/* 工作经历时间线 */
.experience-timeline {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
}

.experience-timeline::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 4px;
  background-color: #e0e0e0;
  border-radius: 4px;
}

.timeline-item {
  position: relative;
  margin-bottom: 40px;
  padding-left: 60px;
}

.timeline-item::before {
  content: "";
  position: absolute;
  left: -12px;
  top: 10px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #4CAF50;
  border: 4px solid white;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
}

.timeline-year {
  position: absolute;
  left: 0;
  top: 0;
  font-size: 1.2rem;
  font-weight: bold;
  color: #4CAF50;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.timeline-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.05);
  font-size: 1.1rem;
  line-height: 1.7;
  color: #555;
}

/* 荣誉成就网格 */
.honors-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.honor-card {
  background-color: white;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  display: flex;
  align-items: flex-start;
  transition: all 0.3s ease;
}

.honor-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
}

.honor-icon {
  font-size: 1.8rem;
  color: #4CAF50;
  margin-right: 15px;
}

.honor-card p {
  color: #555;
  font-size: 1.05rem;
  line-height: 1.5;
}

/* 传承意义样式 */
.significance-content {
  background-color: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  text-align: center;
}

/* 页脚样式 */
.footer {
  background-color: #333;
  color: white;
  padding: 40px 0;
  text-align: center;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .intro-image {
    min-width: 100%;
    height: 300px;
  }
  
  .intro-info {
    padding: 30px;
  }
}

@media (max-width: 768px) {
  .title {
    font-size: 2.2rem;
  }
  
  .subtitle {
    font-size: 1.1rem;
  }
  
  .section-title {
    font-size: 1.8rem;
  }
  
  .intro-card {
    flex-direction: column;
  }
  
  .intro-image {
    height: 280px;
  }
  
  .experience-timeline::before {
    left: 20px;
  }
  
  .timeline-item {
    padding-left: 50px;
  }
  
  .timeline-year {
    left: 20px;
  }
}

@media (max-width: 576px) {
  .header {
    padding: 80px 0 50px;
  }
  
  .title {
    font-size: 1.8rem;
  }
  
  .section-title {
    font-size: 1.5rem;
  }
  
  .intro-image {
    height: 250px;
  }
  
  .intro-info {
    padding: 20px;
  }
  
  .name {
    font-size: 1.8rem;
  }
}

/* 图标样式 (需配合Font Awesome) */
.fas {
  transition: transform 0.3s ease;
}

.honor-card:hover .fas {
  transform: rotate(10deg) scale(1.1);
}
</style>